
import { IUserSession } from '../../../helpers/user-session'

import { LoggerService } from '../../common/common.module'

import { GroupingLocationTypeCreateEditController } from './grouping-locations-types-create-edit.directive.controller'

import { GroupingLocationTypeHelper } from '../grouping-locations-types.helper'

//#region Assets Imports

import * as TEMPLATE from './grouping-locations-types-create-edit.tpl.html'

//#endregion

// Setup

export class GroupingLocationTypeCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger',  'userSession', (
            $scope: any, 
            $q: ng.IQService, 
            $timeout: ng.ITimeoutService, 
            logger: LoggerService,
            userSession: IUserSession
        ) => new GroupingLocationTypeCreateEditController(
            $scope, 
            $q, 
            $timeout, 
            logger, 
            userSession,
            GroupingLocationTypeHelper.REFERENCE_TYPE,
            GroupingLocationTypeHelper.SIMAX_MODULE_NAME 
        )]
            
    template = TEMPLATE
}

// Setup End